module.exports = "https://la-static.vkplay.ru/promo/newstart/img/breaker.9df0d20c.png";